import React, { useMemo } from 'react'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormSubmitButtonInterface } from 'src/shared/entities/form/form-submit-button-sub-entity.schema'
import { BasePublisherButton } from '../base-publisher-button'
import { useOptInSubmitForm } from './hooks/use-opt-in-submit-form'

const TEST_ID = 'submit-form-button'

interface FormSubmitButtonSubEntityProps
  extends Pick<
    ReturnType<typeof useOptInSubmitForm>,
    'isLoading' | 'checkboxesErrors' | 'commonErrors' | 'onSubmit'
  > {
  formEntity: FormInterface
  submitButtonSubEntity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubEntity = ({
  formEntity,
  submitButtonSubEntity,
  isLoading,
  checkboxesErrors,
  commonErrors,
  onSubmit,
}: FormSubmitButtonSubEntityProps) => {
  const subEntity = useMemo(
    () => ({
      ...submitButtonSubEntity,
      ...formEntity.buttonCommonStyles,
    }),
    [submitButtonSubEntity, formEntity.buttonCommonStyles],
  )
  return (
    <BasePublisherButton
      testId={TEST_ID}
      entityOrSubEntity={subEntity}
      onClick={onSubmit}
      errors={[...Object.values(checkboxesErrors), ...commonErrors]}
      isLoading={isLoading}
    />
  )
}
